export const config = {
  id: 'ux-researcher',
  icon: 'User',
  color: 'purple',
  title: 'UX Researcher',
  description: 'User research, usability testing, and behavioral analysis',
  department: 'Design',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 4,
    mid: 3,
    senior: 2
  }
};
